export default __webpack_public_path__ + "static/media/partyFaceEmoji.1bb7fc0a.png";